import { render, staticRenderFns } from "./ProductSelection.vue?vue&type=template&id=1f028770&"
import script from "./ProductSelection.vue?vue&type=script&lang=js&"
export * from "./ProductSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports